import axios from "axios";

// DataVerse URLs
const LOCAL_URL = "http://127.0.0.1:5000";
const DEV_URL = "https://resumereader.dweb.in";
const PROD_URL = "https://talenthub.crm8.dynamics.com";

const currentOrigin =   window.location.origin;
const RESOURCE_URL = DEV_URL
  // currentOrigin === "https://talenthub.intelegain.com" ? PROD_URL : DEV_URL;

const X_CLIENT_KEY = "be90a761-f457-4c02-95d5-7f6822eae8ce";
const API_KEY = "87b8749d-b9c3-4e7a-80aa-2812448183a5";

const resumeServiceInstance = axios.create({
  baseURL: RESOURCE_URL,
  headers: {
    "X-Client-Key": X_CLIENT_KEY,
    "Api-Key": API_KEY,
    Accept: "application/json",
  },
});

export default resumeServiceInstance;
